import { render, staticRenderFns } from "./regionReportApplication.vue?vue&type=template&id=08ccdd57&scoped=true"
import script from "./regionReportApplication.vue?vue&type=script&lang=js"
export * from "./regionReportApplication.vue?vue&type=script&lang=js"
import style0 from "./regionReportApplication.vue?vue&type=style&index=0&id=08ccdd57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ccdd57",
  null
  
)

export default component.exports